'use client';

import { Variants } from 'framer-motion';

// Subtle fade animations
export const fadeIn: Variants = {
    hidden: { opacity: 0 },
    visible: {
        opacity: 1,
        transition: { duration: 0.3, ease: 'easeOut' }
    },
};

export const fadeInUp: Variants = {
    hidden: { opacity: 0, y: 8 },
    visible: {
        opacity: 1,
        y: 0,
        transition: { duration: 0.35, ease: 'easeOut' }
    },
};

export const fadeInScale: Variants = {
    hidden: { opacity: 0, scale: 0.96 },
    visible: {
        opacity: 1,
        scale: 1,
        transition: { duration: 0.3, ease: 'easeOut' }
    },
};

// Stagger container for child animations
export const staggerContainer: Variants = {
    hidden: { opacity: 0 },
    visible: {
        opacity: 1,
        transition: {
            staggerChildren: 0.05,
            delayChildren: 0.1,
        },
    },
};

export const staggerItem: Variants = {
    hidden: { opacity: 0, y: 6 },
    visible: {
        opacity: 1,
        y: 0,
        transition: { duration: 0.25, ease: 'easeOut' }
    },
};

// Spring animations for interactive elements
export const springTap = {
    scale: 0.97,
    transition: { type: 'spring', stiffness: 400, damping: 25 }
};

export const springHover = {
    scale: 1.02,
    transition: { type: 'spring', stiffness: 300, damping: 20 }
};

// Slide animations
export const slideInLeft: Variants = {
    hidden: { opacity: 0, x: -12 },
    visible: {
        opacity: 1,
        x: 0,
        transition: { duration: 0.25, ease: 'easeOut' }
    },
    exit: {
        opacity: 0,
        x: -8,
        transition: { duration: 0.15 }
    },
};

export const slideInRight: Variants = {
    hidden: { opacity: 0, x: 12 },
    visible: {
        opacity: 1,
        x: 0,
        transition: { duration: 0.25, ease: 'easeOut' }
    },
    exit: {
        opacity: 0,
        x: 8,
        transition: { duration: 0.15 }
    },
};

// Tooltip animation
export const tooltipVariants: Variants = {
    hidden: { opacity: 0, x: 4, scale: 0.95 },
    visible: {
        opacity: 1,
        x: 0,
        scale: 1,
        transition: { duration: 0.15, ease: 'easeOut' }
    },
    exit: {
        opacity: 0,
        x: 4,
        transition: { duration: 0.1 }
    },
};

// Dropdown animation
export const dropdownVariants: Variants = {
    hidden: { opacity: 0, y: -4, scale: 0.98 },
    visible: {
        opacity: 1,
        y: 0,
        scale: 1,
        transition: { duration: 0.2, ease: 'easeOut' }
    },
    exit: {
        opacity: 0,
        y: -4,
        scale: 0.98,
        transition: { duration: 0.15 }
    },
};
